import { render, staticRenderFns } from "./LuConcernGrid.vue?vue&type=template&id=72eba0fb"
import script from "./LuConcernGrid.vue?vue&type=script&lang=js"
export * from "./LuConcernGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports